const TheDisarrange = (props) => {
    return (
        <div className="lyrics eggshell">
            <h2>The Disarrange</h2>
            <h4>Jennifer Michael Hecht (disarranged by Luis Andrei Cobo)</h4>
            <p>To begin is to let things out of control.<br/>
            How bear such burdens? How do people do<br/>
            what you are still afraid of? <br/>
            Of the quakiness of infancy and old age <br/>
            we shimmer and shimmy into being <br/>
            and out again.<br/>
            <br/>
            To begin is to help things out of control.<br/>
            A quick check of the ocean, or any fire,<br/>
            is a reminder of how things seem.<br/>
            It is important to let sense quiver;<br/>
            even living aboard a boat mired<br/>
            in mud in view of the sea.<br/>
            <br/>
            To begin is to let thoughts out of control.<br/>
            Who wants yet another world?<br/>
            It's enough already.<br/>
            <br/>
            <small>Reprinted with permission.<br/>&copy;Jennifer Michael Hecht. All Rights Reserved</small>
            </p>
        </div>
    )
}
export default TheDisarrange;